module.exports = __webpack_public_path__ + "img/aidtools_produce_txt.a53134d6.png";